































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { BACKEND_URL } from '@/helpers/constants';
import Booking from '@/models/Booking';
import LotTable from '@/components/prescriber/LotTable.vue';
import AuthModule from '@/store/AuthModule';

@Component({
    components: {
        LotTable,
    },
})
export default class BookingInfos extends Vue {
    @Prop() booking!: Booking | undefined;
    @Prop({ type: Boolean, default: false }) asAdmin!: boolean;
    BACKEND_URL = BACKEND_URL;

    isAdmin() {
        return this.asAdmin;
    }

    get hasCommission(): boolean {
        const value = this.booking && (this.booking as any).taux_commission;
        return value !== null && value !== undefined && value !== '';
    }

    get commissionDisplay(): string {
        if (!this.hasCommission) {
            return 'NC';
        }

        const value = Number((this.booking as any).taux_commission);
        if (isNaN(value)) {
            return 'NC';
        }

        return `${value.toLocaleString('fr-FR', { maximumFractionDigits: 2 })}%`;
    }

    get notaries() {
        if (
            !this.booking ||
            !this.booking.notary_buyer ||
            !this.booking.notary_promoter
        ) {
            return [];
        }

        return [
            {
                type: 'acquéreur',
                office: this.booking.notary_buyer.office,
                person: `${this.booking.notary_buyer.firstname} ${this.booking.notary_buyer.lastname}`,
                phone: this.booking.notary_buyer.phone,
            },
            {
                type: 'promoteur',
                office: this.booking.notary_promoter.office,
                person: `${this.booking.notary_promoter.firstname} ${this.booking.notary_promoter.lastname}`,
                phone: this.booking.notary_promoter.phone,
            },
        ];
    }
}
